module.exports = __webpack_public_path__ + "img/appAsset-brand--Visa.fbf55a99.svg";